import { mapState, mapActions } from "vuex";
import { defineAsyncComponent } from 'vue';

export default {
    components: {
        i18n: defineAsyncComponent(() => import("@/toremove/components/octolo/utils/i18n.vue")),
    },
    computed: {
        ...mapState('User',   ['tr_', 'isTranslateLoad']),
    },
    methods: {
        ...mapActions("User", ["getTranslate", "setTranslate"]),
        async loadTranslate(force){
            if(force || !this.isTranslateLoad)
                await this.setTranslate();
        },
        _tr(tr, dflt) {
            var tr_ = this.getDescendantVal(tr, this.tr_);
            return tr_ ? tr_ : dflt;
        },
    }
}
